/**
 * ExcelDownloadButton.jsx — Reusable Excel download button component.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { exportToExcel } from "../../utils/excelExport";

export default function ExcelDownloadButton({
    columns,
    data,
    filename = "report",
    disabled = false,
    label,
    onExport,
    className = "",
}) {
    const { t } = useTranslation();
    const buttonLabel = label ?? t("common.downloadExcel");

    const handleClick = () => {
        if (disabled) return;
        if (onExport) {
            onExport();
            return;
        }
        if (!columns || !data) return;
        exportToExcel(columns, data, filename);
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            disabled={disabled}
            title={disabled ? t("common.noDataExport") : t("common.downloadAsExcel")}
            className={`btn-page-action-export ${className}`.trim()}
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="8" y1="13" x2="16" y2="13" />
                <line x1="8" y1="17" x2="16" y2="17" />
                <line x1="10" y1="9" x2="8" y2="9" />
            </svg>
            {buttonLabel}
        </button>
    );
}
